import { render, staticRenderFns } from "./MoveRecord.vue?vue&type=template&id=05b9a53b&scoped=true"
import script from "./MoveRecord.vue?vue&type=script&lang=js"
export * from "./MoveRecord.vue?vue&type=script&lang=js"
import style0 from "./MoveRecord.vue?vue&type=style&index=0&id=05b9a53b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b9a53b",
  null
  
)

export default component.exports